import { useMutation } from "@tanstack/react-query";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { apiClient } from "../../../zodios/client";
import { setDefaultMarketPlace } from "../../../redux/reducers/userReducer";
import { handleProfileOrMarketplaceChangeRedirects } from "utils/handleDefaultMarketplace";
import { useHistory } from "react-router";

export const useSetDefaultMarketplace = () => {
  const user = useAppSelector((state) => state.user);
  const dispatch = useAppDispatch();
  const history = useHistory();

  return useMutation({
    mutationFn: async (marketplaceId: string) => {
      const currentDefaults = { ...user.defaultMarketplace };
      currentDefaults[user.organization_id] = marketplaceId;

      handleProfileOrMarketplaceChangeRedirects(history);
      await apiClient.putUserProfileMarketplaces({ default_marketplace: currentDefaults });

      dispatch(
        setDefaultMarketPlace({
          orgId: user.organization_id,
          marketplace: marketplaceId,
        }),
      );
    },
  });
};
